const mEditionAcademyAutorespondersConnectAutoresponder = {
  mEditionAcademyAutorespondersConnectAutoresponder: {
    alerts: {
      createAcademiaAutoresponder: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La cuenta de autoresponder fue asociada exitosamente.'
      }
    },

    buttonPrimary: 'ASOCIAR',

    inputs: {
      descripcion: {
        label: 'Descripción',
        placeholder: 'Mi Cuenta de Autoresponder'
      }
    },

    redirect: 'Espera un momento, serás redireccionado...',
    title: 'Completa la información de tu cuenta de',

    validation: {
      required: 'Información requerida.'
    }
  }
}

export default mEditionAcademyAutorespondersConnectAutoresponder
